import type {
  MiddlewareMisspellingsPipeDetails,
  MiddlewarePipeDetails,
  PipeDetailsAdditionalData,
} from './models/middleware-pipe-details.model';
import type { SearchTab } from '../../components/result-page/search-tab/search-tab';
import type { SearchApi } from '../../api/model/response/ApiResponse';
import type { SearchData } from '../../models/common/search-data.model';
import { from, Observable } from 'rxjs';
import {middlewarePipe} from './middleware-pipe';

import type {DashboardMisspellings} from '../../components/result-page/search-tab/subcomponents/dashboard-tab-view/dashboard-misspellings/dashboard-misspellings';


export interface MiddlewarePipeAdapterConfig {
    customMiddlewares?: string
    updateOnlyMobileStates?: boolean;
    withToken?: boolean
}

export function middlewareSearchTabAdapater<T>(
  searchTab: SearchTab,
  adapterConfig: MiddlewarePipeAdapterConfig,
  additionalData?: PipeDetailsAdditionalData
): Observable<SearchApi|SearchData|any|T> {  //eslint-disable-line
    let initialDetails: MiddlewarePipeDetails = {
      context: searchTab,
      middlewareRequest:{
        timeout: searchTab.timeout,
        apiEndpoint: searchTab.apiEndpoint.toString(),
      },
      config: adapterConfig
    };

    if(additionalData) {
      initialDetails = {...initialDetails, ...{additionalData}};
    }

    return from((middlewarePipe)(initialDetails));
}

export function middlewareMisspellingsAdapater<T>(
  searchTab: DashboardMisspellings,
  adapterConfig: MiddlewarePipeAdapterConfig,
  additionalData?: PipeDetailsAdditionalData
): Observable<any|T> {  //eslint-disable-line
    let initialDetails: MiddlewareMisspellingsPipeDetails = { // change type
      context: searchTab,
      middlewareRequest:{
        timeout: searchTab.timeout,
        apiEndpoint: searchTab.apiEndpoint.toString(),
      },
      config: adapterConfig
    };

    if(additionalData) {
      initialDetails = {...initialDetails, ...{additionalData}};
    }

    return from((middlewarePipe)(initialDetails));
}
